/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VerifyKYCStepOneParam { 
    /**
     * Front of the identity card that is to be verified. Must be a .jpeg
     */
    identityCardFrontPhoto: string;
    /**
     * Back of the identity card that is to be verified. Must be a .jpeg
     */
    identityCardBackPhoto?: string;
}

